<template>
    <div class="main-section main-section--dashboard">
        <vue-custom-scrollbar
                id="main-chat-section"
                class="scroll-area"
                :settings="settings"
        >
            <ul class="main-chat" id="mainChat">
                <template v-if="dashboard.data !== 'undefined' && dashboard.data.length > 0">
                    <app-message-dashboard v-for="item in dashboard.data" :item="item"
                                           :key="item.id"></app-message-dashboard>
                </template>
                <template v-else>
                    <p class="no-more-unread-messages">{{ $t('no-unread-messages') }}</p>
                </template>
            </ul>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import MessageDashboard from './MessageDashboard.vue';
    import vueCustomScrollbar from 'vue-custom-scrollbar'

    export default {
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60,
                    swipeEasing: true,
                    suppressScrollX: true
                },
            }
        },
        components: {
            appMessageDashboard: MessageDashboard,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        computed: {
            ...mapGetters([
                'dashboard'
            ]),
        },
        methods: {
        },

    }
</script>

<style scoped>

    .scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: 100%;
    }

    .no-more-unread-messages {
        margin: 80px 50px;
        text-align: center;
        font-size: 16px;
    }
</style>